export class PortalLeadsData {

    constructor(

      public Created: string,                     // Required
      public Updated: string,                    // Required
      public Status: string,                      // Required
      public Source: string,                         // Required
      public EnquiryDate: string,               // Required
      public PortalBranchId: Number,                  // Required
      public CustDPA: boolean,                       // Required
      public Notes?: string,                      // Optional
      public EnquiryId?: Number,                          // Optional
      public BranchRef?: string,                     // Optional
      public CustTitle?: string,                      // Optional
      public CustFirstname?: string,                 // Optional
      public CustSurname?: string,                 // Optional
      public CustAddress?: string,                  // Optional
      public CustPostcode?: string,                    // Optional
      public CustDayPhone?: string,                    // Optional
      public CustEvePhone?: string,                    // Optional
      public CustEmail?: string,                       // Optional
      public CustPreferredContactMethod?: string,      // Optional
      public CustPreferredContactTime?: string,      // Optional
      public CustMovingDate?: string,             // Optional
      public CustCurrSaleStatus?: string,             // Optional
      public CustPropertyToSell?: boolean,                 // Optional
      public CustArrangeValuation?: boolean,               // Optional
      public CustArrangeViewing?: boolean,                // Optional
      public CustHelpWithMortgage?: boolean,               // Optional
      public CustSendPropDetails?: boolean,                // Optional
      public PropReference?: string,                   // Optional
      public CustSearchPropertyType?: string,        // Optional
      public CustSearchPriceMin?: string,              // Optional
      public CustSearchPriceMax?: string,             // Optional
      public CustSearchLocation?: string,              // Optional
      public CustSearchBedroomMin?: string,           // Optional
      public ToEmail?: string,                   // Optional

      ) {  }
}


// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/viewingForm/portalLeadsData.ts